import { render, staticRenderFns } from "./FormAdmin.vue?vue&type=template&id=3ab9f56c&scoped=true&"
import script from "./FormAdmin.vue?vue&type=script&lang=js&"
export * from "./FormAdmin.vue?vue&type=script&lang=js&"
import style0 from "./FormAdmin.vue?vue&type=style&index=0&id=3ab9f56c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab9f56c",
  null
  
)

export default component.exports